// extracted by mini-css-extract-plugin
export default {"gearList":"affordableGear_gearList__ES1W6","starterSet":"affordableGear_starterSet__VQqqw","faq":"affordableGear_faq__TvWI5"};